import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { StripeOnboardingRouter } from "./Router";

export function StripeOnboardingContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <StripeOnboardingRouter />
    </ThemeProvider>
  );
}
